import { Component, ChangeDetectionStrategy, Input, WritableSignal, TemplateRef, ViewChild, ElementRef, input } from '@angular/core';
import { UBaseInfraComponent } from '../u-base-infra.component';

@Component({
  selector: 'u-sidebar',
  templateUrl: './u-sidebar.component.html',
  styleUrls: ['./u-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class USidebarComponent extends UBaseInfraComponent {
  visible = input.required<WritableSignal<boolean> | boolean>();

  readonly header = input<TemplateRef<any> | undefined>(undefined);
  readonly content = input<TemplateRef<any> | undefined>(undefined);
  readonly footer = input<TemplateRef<any> | undefined>(undefined);
  readonly position = input<'start' | 'end'>('start');
  readonly styles = input<{ [key: string]: any } | undefined>(undefined);
  readonly showMask = input<boolean>(false);

  get visibleValue(): boolean {
    const visibleValue = this.visible();
    return typeof visibleValue === 'function' ? (visibleValue as WritableSignal<boolean>)() : visibleValue;
  }

  getIconRef() {
    return null;
  }
}
